import { render, staticRenderFns } from "./StandardButtonLoader.vue?vue&type=template&id=149d2852&scoped=true"
import script from "./StandardButtonLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./StandardButtonLoader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StandardButtonLoader.vue?vue&type=style&index=0&id=149d2852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149d2852",
  null
  
)

export default component.exports